import { Singleton } from "util";
import BaseService from "./base.service";

@Singleton
class SatService extends BaseService {
  async getSat() {
    return await this.get(`/sat_association_code.json`);
  }
}

export default SatService;



// WEBPACK FOOTER //
// ./src/core/service/sat.service.js